import { Clickable } from 'components/common/Clickable'
import { useEffect, useRef } from 'react'

import styles from './styles.module.css'

type ItemProps = {
    disabled?: boolean
    children?: React.ReactNode
    onClick?: () => void
}

const Item: React.FC<ItemProps> = ({
    disabled,
    children,
    onClick,
 }) => (
    <Clickable
        disabled={disabled}
        className={ styles.item }
        type='group'
        onClick={ onClick } >
        { children }
    </Clickable>
)

export const MenuList: React.FC<{
    children?: React.ReactNode
}> & {
    Item: typeof Item
} = (props) => {
    const contentRef = useRef<HTMLDivElement>(null)
    useEffect(() => {
        contentRef.current?.focus()
    }, [])
    const {
        children
    } = props

    return (
        <div
            className={ styles.root }
            onClick={(e) => e.stopPropagation()}
            ref={contentRef}
            tabIndex={0}>
            { children }
        </div>
    )
}
MenuList.Item = Item
